module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAZlBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8vVg1eeAAAAIXRSTlMAA/l7I9rJu6qIgmtQ9e3mWRvTkHJCOzgs89WhZEYuEgq03mUTAAAAhElEQVQY013QWQ4CIRBF0cfc0PNkO+vb/yaVAJpwPm9SgSpEYmpGDjbMKE6GSa9y6STlbTp2ZchGxHLuueg0r8iAL0fzQqYoNaDJDoVY6IGWg0CxklTwdPjz3FAlHIiDIyqafOAnveR4fZfScstftXMukqEsdFl3/bzbuFC1tlS51Mf5AO9fCeIqjs4qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_turn_r_hover.png
// module id = /Pvr
// module chunks = 9